import React from 'react';
import base from "../base";

class SectionAboutMe extends React.Component {

  state = {
    desc: {}
  };

  componentWillMount() {
    this.ref = base.syncState("aboutMeDescription", {
      context: this,
      state: 'desc'
    });
  }


  componentDidUpdate() {
    document.getElementsByClassName('section-about-me-text')[0].innerHTML = String(this.state.desc);
    console.log("INNER HTML: " + document.getElementsByClassName('section-about-me-text')[0].innerHTML);

    this.props.onChange(this.state);
    //console.log("INNER = " + document.getElementsByClassName('header-about-me').innerHTML);
    //console.log("DeSsc: " + this.state.desc);
  }

  render() {
    return (
      <p className="section-about-me-text">
        Loading..
      </p>
    );
  }
}

export default SectionAboutMe;
